import { TOAST_TIMEOUT } from 'src/config/Toast';
import type { Modification, ModificationWithRegionsAndTasksDTO } from 'src/services/modification/types';
import store from 'src/store';
import { createToast } from 'src/store/toastsSlice';
import apiClient from 'src/utils/apiClient';

// **** Functions **** //

/**
 * Get modifications
 */
async function getModifications() {
  const res = await apiClient.get<Modification[]>('/modifications');
  return res.data;
}

/**
 * Get modifications
 */
async function getModificationWithRegionsAndTasksDTOList() {
  const res = await apiClient.get<ModificationWithRegionsAndTasksDTO[]>(
    '/modifications/modificationWithRegionsAndTasksDTOList',
  );
  return res.data;
}

/**
 * Create or update modification
 */
async function createOrUpdateModifications(payload: Modification) {
  const res = await apiClient.post<Modification>('/modifications', payload);
  if (res) {
    store.dispatch(
      createToast({
        type: 'success',
        message: 'Saved modification successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  }
  return res.data;
}

/**
 * Delete modification
 */
async function deleteModification(modificationId: number) {
  const res = await apiClient.delete(`/modifications/${modificationId}`);
  if (res) {
    store.dispatch(
      createToast({
        type: 'success',
        message: 'Deleted modification successfully',
        timeout: TOAST_TIMEOUT,
      }),
    );
  }
}

// **** Export **** //

export default {
  getModifications,
  getModificationWithRegionsAndTasksDTOList,
  createOrUpdateModifications,
  deleteModification,
} as const;
